import React from "react";
import {
  Address,
  FooterLink,
  InfoColumn,
  InfoContainer,
  InfoDescription,
  InfoRow,
  InfoTitle,
} from "./footer.styles";
import PhoneIcon from "assets/icons/phone.svg";
import EmailIcon from "assets/icons/email.svg";
import ArrowRight from "assets/icons/arrow-right.svg";
import LogoPrefeiura from "assets/images/logo-prefeitura.svg";
import { useAppState } from "main/context/app-context";

export function Footer() {
  const { applicationData } = useAppState();
  return (
    <div id="footer">
      <>
        <InfoContainer background={"blue"}>
          <InfoColumn>
            <InfoTitle>Horário de atendimento</InfoTitle>
            <InfoDescription>
              O funcionamento da {applicationData?.entity?.name} é de Segunda à
              Sexta-feira na parte da manhã das 8h às 11:45 e das 13:15 às 17h.
            </InfoDescription>
          </InfoColumn>
          <InfoColumn>
            <InfoTitle>Fale conosco</InfoTitle>
            <InfoRow>
              <img src={PhoneIcon} alt="Telefone" />
              <InfoDescription>{applicationData?.entity?.contact?.formattedBusinessPhone}</InfoDescription>
            </InfoRow>
            <InfoRow>
              <img src={EmailIcon} alt="Email" />
              <InfoDescription>
                {applicationData?.entity?.contact?.email}
              </InfoDescription>
            </InfoRow>
          </InfoColumn>
          <InfoColumn>
            <InfoTitle>Ouvidoria</InfoTitle>
            <InfoDescription>
              Nossa prefeitura quer te ouvir! <br /> Deixe suas críticas e
              sugestões.
            </InfoDescription>
            <InfoRow>
              <FooterLink href="/ouvidoria">Acessar Ouvidoria</FooterLink>
              <img src={ArrowRight} alt="Ouvidoria" />
            </InfoRow>
          </InfoColumn>
        </InfoContainer>
        <InfoContainer background="white" alignCenter>
          <img src={"data:image/png;base64, " + applicationData?.entity?.brandLogo} alt={applicationData?.entity?.name} height={100} />
          <Address>
            <strong>{applicationData?.entity?.name}</strong> <br />
            {applicationData?.entity?.address?.formattedAddress}
          </Address>
        </InfoContainer>
      </>
    </div>
  );
}
